<template>
    <div id="home">
      <ImageSlider />
      <OnamaHome />
      <LastPhotos />
      <LastVideos />
      <Contact />
      <!-- <Instagram /> -->
      <router-view/> 
    </div>
</template>
<script>
import axios from 'axios';

import ImageSlider from './Slider/ImageSlider'
import OnamaHome from './Home/OnamaHome'
import LastPhotos from './Home/LastPhotos'
import LastVideos from './Home/LastVideos'
import Contact from './home/Contact'
import Instagram from './home/Instagram'

export default {  
  components: {
    ImageSlider,
    OnamaHome,
    LastPhotos,
    LastVideos,
    Contact,
    Instagram
  },  
  metaInfo(){
    return{
      title: 'S light production, najam koncertne opreme,rasvjeta za vjenčanja',
      meta:[
        {
          name: 'description',
          content: 'S light production, najam koncertne opreme, rasvjeta za vjenčanja, specijalni efekti za razne događaje, teški dim, hladne fontane, umjetni snijeg, balončići.'
        }
      ]
    }
  },  
   data(){
      return{
          text:'',
          description:'',
          image:''
        }
   },
   methods:{
      fetchData(){
        var url = this.apiPath + 'about_us/read.php';
        axios({
          method: 'get',
          url: url,
        })
        .then(function(response) {
          this.text = response.data.Text;
          this.description = response.data.DescriptionShort;
          this.image = response.data.Image;
        }.bind(this))
        .catch((error) => {
          console.log(error);
        });  
      }
   },
   created(){
       this.fetchData();
   }     
}
</script>

<style lang="scss">
  .about-us-section{
    .container{
      background: green;
      width: 100%;
      padding-right: 15px;
      padding-left: 15px;   
    }
    background: red;
  }

@media only screen and (max-width: 768px) {
  .about-us-section{
    .container{
    }
  }
}  
</style>





// WEBPACK FOOTER //
// src/components/Home.vue